import { render, staticRenderFns } from "./MessageBell.vue?vue&type=template&id=508cbea4&scoped=true&"
import script from "./MessageBell.vue?vue&type=script&lang=js&"
export * from "./MessageBell.vue?vue&type=script&lang=js&"
import style0 from "./MessageBell.vue?vue&type=style&index=0&id=508cbea4&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "508cbea4",
  null
  
)

export default component.exports